import Dexie from "./node_modules/dexie/dist/dexie.es.js";

class db {
	constructor() {
		this.error = { error: "db is not configured" };
		this._db = this.error;
	}

	reconfigureDb(dbName) {
		if (dbName) {
			if (this._db.name === dbName) {
				return;
			} else {
				this._db = new Dexie(dbName);

				this._db.version(1).stores({
					inspections: "_key, status",
					images: "id, inspectionId",
					drawings: "id, inspectionId",
					syncLog: "id, inspectionId"//TODO: rename to syncQueue
				});
			}
		} else if (this._db && this._db !== this.error) {
			this._db.close();
			this._db = this.error;
		}
	}

	get images() {
		if (db.error) 
			console.error(db.error);
		
		return this._db.images;
	}

	get drawings() {
		if (db.error) 
			console.error(db.error);
		
		return this._db.drawings;
	}

	get inspections() {
		if (db.error) 
			console.error(db.error);
		
		return this._db.inspections;
	}

	get syncLog() {
		if (db.error) 
			console.error(db.error);
		
		return this._db.syncLog;
	}

	get transaction() {
		if (db.error) 
			console.error(db.error);
		
		return this._db.transaction.bind(this._db);
	}

	get db() {
		return this._db;
	}
}

export default new db();
